import { render, staticRenderFns } from "./FeaturedCreators.vue?vue&type=template&id=7ff4dbc8&scoped=true"
import script from "./FeaturedCreators.vue?vue&type=script&lang=js"
export * from "./FeaturedCreators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff4dbc8",
  null
  
)

export default component.exports